// base in 1.7.6
// export this package's api
import Drawer from './Drawer'

export default Drawer



// WEBPACK FOOTER //
// ./components/vc-drawer/src/index.js